import styled from "styled-components";

const LoadingWrapper = styled.div`
    padding-top: 20rem;
    position: relative;
`;

export default LoadingWrapper;
